/* global angular, _*/

var ngModule = angular.module('trends');
var $ = jQuery;
var ALL_GROUPS = 'all';

ngModule.directive('andOrToggle', [
    function () {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element) {
                var and_button = element.find('button.and');
                var or_button = element.find('button.or');

                var setAnd = function (new_state, e) {
                    e.stopPropagation();
                    scope.$apply(scope.setFilterAnd(scope.group, new_state));
                };
                and_button.on('click', _.wrap(true, setAnd));
                and_button.on('keypress', function(event) {
                    if (event.which === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        _.wrap(true, setAnd);
                    }
                });
                or_button.on('click', _.wrap(false, setAnd));
                and_button.on('keypress', function(event) {
                    if (event.which === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        _.wrap(false, setAnd);
                    }
                });
            }
        };
    }]);

ngModule.directive('filterGroup', [
    function () {
        return {
            restrict: 'A',
            replace: false,
            scope: true,
            template: '<div ng-include="filterGroupTemplate()"></div>',
            link: function (scope) {
                scope.filterGroupTemplate = function () {
                    var template = '/trends/partials/filter_group/';
                    if (scope.group.custom_view) {
                        template = template + scope.group.custom_view + '/';
                    } else if (scope.group.and_or) {
                        template = template + 'and_or/';
                    }
                    return template;
                };
            }
        };
    }]);

ngModule.directive('filterDisplay', [
    function () {
        return {
            restrict: 'A',
            replace: false,
            scope: true,
            template: '<div ng-include="filterDisplayTemplate()"></div>',
            link: function (scope) {
                scope.filterDisplayTemplate = function () {
                    var template = '/trends/partials/filter_display/';
                    if (scope.group.custom_display) {
                        template = template + scope.group.custom_display + '/';
                    } else if (scope.group.and_or) {
                        template = template + 'and_or/';
                    }
                    return template;
                };
            }
        };
    }]);

ngModule.directive('timeFilterDisplay', [
    function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope) {
                scope.$watch('params.filters.timespan', function (value) {
                    if (value) {
                        var start = { day: value.sd, month: value.sm, year: value.sy };
                        var end = { day: value.ed, month: value.em, year: value.ey };
                        if (
                            start.year > end.year ||
                            (start.year === end.year && start.month > end.month) ||
                            (start.year === end.year && start.month === end.month && start.day > end.day)
                        ) {
                            var tmp = start;
                            start = end;
                            end = tmp;
                        }
                        scope.start_date = (start.day ? start.day + ' ' : '') +
                            scope.calendarMonths[start.month-1] + ' ' + start.year;
                        scope.end_date = (end.day ? end.day + ' ' : '') +
                            scope.calendarMonths[end.month-1] + ' ' + end.year;
                    }
                }, true);
            }
        };
    }]);


ngModule.directive('searchFilters', [
    function() {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope) {
                scope.setFilterGroups = function (groups) {
                    angular.forEach(groups, function (group, k) {
                        group.closed = true;
                        group.key = k;

                        angular.forEach(group.filters, function (filter) {
                            filter.group_key = k; // Attach the key to make access easier later
                            filter.closed = true;

                            // create a unified subfilter group
                            if (filter.subfilter) {
                                filter.subfilter.key = filter.subfilter_key;
                                filter.subfilter.group_key = filter.subfilter_key;
                                angular.forEach(filter.subfilter.filters, function(subfilter) {
                                    subfilter.group_key = filter.subfilter_key;
                                });

                                if (!scope.subfilters[filter.subfilter_key]) {
                                    scope.subfilters[filter.subfilter_key] = angular.extend({}, filter.subfilter) ;
                                }
                                else {
                                    var subfilters = scope.subfilters[filter.subfilter_key];
                                    subfilters.filters = subfilters.filters.concat(filter.subfilter.filters);
                                }
                            }
                        });
                    });

                    scope.filters = groups;
                };

                scope.filterIsAnd = function (group) {
                    var andfields = scope.params.filters.andfields;
                    return andfields && _.includes(andfields, group.key);
                };

                scope.setFilterAnd = function (group, new_state) {
                    var andfields = scope.params.filters.andfields;
                    if (new_state && !scope.filterIsAnd(group)) {
                        if (!andfields) {
                            andfields = scope.params.filters.andfields = [];
                        }
                        andfields.push(group.key);
                    } else if (!new_state && scope.filterIsAnd(group)) {
                        andfields.splice(andfields.indexOf(group.key), 1);
                        if (!andfields) {
                            delete scope.params.filters.andfields;
                        }
                    }
                };

                scope.toggleFilterAndOr = function (group) {
                    scope.setFilterAnd(group, !scope.filterIsAnd(group));
                };

                scope.toggleFilter = function (filter) {
                    var remove = false;
                    var filters = scope.params.filters[filter.group_key] || [];

                    if (!scope.isFilterActive(filter)) {
                        filters.push(filter.id);

                        // if super filter then delete all the subs
                        if (filter.subfilter) {
                            var child_filters = scope.params.filters[filter.subfilter_key];
                            if (child_filters) {
                                angular.forEach(filter.subfilter.filters,
                                    function(f) {
                                        var index = child_filters.indexOf(f.id);
                                        if (index !== -1) {
                                            child_filters.splice(child_filters.indexOf(f.id), 1);
                                        }
                                    }
                                );
                            }
                        }

                        // if all the subs are active then toggle the super
                        if (filter.parent_key) {
                            var parent_filter_obj = scope.getFilter(filter.parent_key, filter.parent_value);

                            var sub_filter_block = scope.params.filters[filter.group_key];
                            if (sub_filter_block) {
                                var override = true;

                                var parent_filters = parent_filter_obj.subfilter.filters;
                                for (var i=0 ; i<parent_filters.length ; i++) {
                                    if (sub_filter_block.indexOf(parent_filters[i].id) === -1) {
                                        override = false;
                                        break;
                                    }
                                }

                                if (override) {
                                    scope.toggleFilter(parent_filter_obj);
                                }
                            }
                        }
                    } else {
                        // subfilters under an active superfilter will always end up here
                        // as they are considered active
                        if (filter.parent_key) {
                            // check if the parent is active
                            var culled = false;
                            var parent_filter = scope.params.filters[filter.parent_key];
                            if (parent_filter && parent_filter.indexOf(filter.parent_value) !== -1) {
                                parent_filter.splice(parent_filter.indexOf(filter.parent_value), 1);
                                culled = true;
                            }
                            // if a super was removed add all the subs excluding the one that was uncliucked
                            if (culled) {
                                var parent_filter_obj = scope.getFilter(filter.parent_key, filter.parent_value);

                                var sub_filter_block = scope.params.filters[filter.subfilter_key] || [];
                                angular.forEach(parent_filter_obj.subfilter.filters, function(subfilter) {
                                    sub_filter_block.push(subfilter.id);
                                });

                                filters = sub_filter_block;
                            }
                        }

                        if (filters.length === 1) {
                            remove = true; // Remove the entire array, since there's now no filters
                        } else {
                            filters.splice(filters.indexOf(filter.id), 1);
                        }

                    }

                    if (remove) {
                        delete scope.params.filters[filter.group_key];
                    } else {
                        scope.params.filters[filter.group_key] = filters;
                    }
                };

                scope.emptyFilterGroup = function (group_key) {
                    var filters = scope.lastParams.filters[group_key];
                    var hiddenGroups = ['timespan'];
                    if (
                        filters === undefined ||
                        angular.equals(filters, {}) ||
                        angular.equals(filters, []) ||
                        hiddenGroups.indexOf(group_key) !== -1
                    ) {
                        return true;
                    }
                    return false;
                };

                scope.isFilterSelectable = function (filter) {
                    // Allow the filter to be changed if:
                    // - focus is ALL
                    // - facets are unused for that filter group or
                    // - the facet is null (i.e. zero) or
                    // - the facet is already selected
                    if (scope.focus !== ALL_GROUPS) {
                        var group = scope.getFilterGroup(filter.group_key);
                        if (group.facet_key) {
                            var facet = scope.getFacet(filter);
                            if (!facet) {
                                return scope.isFilterActive(filter);
                            }
                        }
                    }

                    return true;
                };

                scope.clearFilters = function () {
                    scope.params.filters = {};
                    scope.lastParams.filters = {};
                };

                scope.isFilterActive = function (filter) {
                    if (!scope.params.filters) {
                        return false;
                    }

                    if (filter.parent_key) {
                        // if its a subfilter then it counts as active if the parent is active
                        var parentFilter = scope.params.filters[filter.parent_key];
                        if (parentFilter && parentFilter.indexOf(filter.parent_value) !== -1) {
                            return true;
                        }
                    }

                    var selectedFilters = scope.params.filters[filter.group_key];
                    return selectedFilters && selectedFilters.indexOf(filter.id) !== -1;
                };

                scope.getFilterGroup = function (group_key) {
                    var data = scope.filters[group_key];
                    if (!data) {
                        data = scope.subfilters[group_key];
                    }

                    return data;
                };

                scope.allFilters = function () {
                    return _.values(scope.filters).concat(_.values(scope.subfilters));
                };

                scope.getFilter = function (group_key, id) {
                    var group = scope.getFilterGroup(group_key);
                    return _.find(group.filters, 'id', id);
                };

                scope.getLimitFilters = function() {
                    var others = scope.getMainFilters();
                    return _.filter(scope.filters, function (x) { return others.indexOf(x) === -1; });
                };

                scope.getMainFilters = function() {
                    var filters = _.filter(scope.filters, 'and_or');
                    filters.sort(function(a,b) {
                        return a.order - b.order;
                    });
                    return filters;
                };

                /* Get filters for categories which need to be encoded together */
                scope.getFilterCategories = function () {
                    return _.map(angular.extend({}, scope.params.filters.sector,
                            scope.params.filters.demographic, scope.params.filters.driver)); // HACK
                };
            }
        };
    }
]);

ngModule.directive('betweenDatesFilter',
    function() {
        return {
           restrict: 'A',
           scope: true,
           link: function(scope, element, attrs) {
                var currentDate = new Date();
                var currentYear = currentDate.getFullYear();
                var collapsingTarget = '.filter_year_span.panel-collapse';
                var enableDayFiltering = scope.$eval(attrs.enableDayFiltering || 0);
                scope.years = [];
                for (var d=2007; d <= currentYear; d++) {
                    scope.years.push(d);
                }
                scope.timespan = {};
                if (scope.params.filters.timespan !== undefined) {
                    scope.timespan = scope.params.filters.timespan;
                }
                else {
                    scope.timespan.sm = currentDate.getMonth()+1;
                    scope.timespan.em = currentDate.getMonth()+1;
                    scope.timespan.sy = currentYear-1;
                    scope.timespan.ey = currentYear;
                    if (enableDayFiltering) {
                        scope.timespan.sd = 1;
                        scope.timespan.ed = currentDate.getDate();
                    }
                }
                scope.currentDateSet = false;
                scope.toggleCurrentDate = function() {
                    scope.currentDateSet = !scope.currentDateSet;
                    if (scope.currentDateSet) {
                        scope.timespan.ey = currentYear;
                        scope.timespan.em = currentDate.getMonth()+1;
                        if (enableDayFiltering) {
                            scope.timespan.ed = currentDate.getDate();
                        }
                    }
                };
                scope.timespanDatesCollapsed = true;
                scope.timespanDatesToggling = function(filter_id, collapsingTarget) {
                    var collapsingTarget = $(collapsingTarget);
                    filter_id = filter_id || -1;
                    if (!scope.timespanDatesCollapsed && filter_id !== 2) {
                        collapsingTarget.removeClass('in');
                        scope.timespanDatesCollapsed = true;
                        delete scope.params.filters.timespan;
                    }
                    else if (scope.timespanDatesCollapsed && filter_id === 2) {
                        collapsingTarget.addClass('in');
                        scope.timespanDatesCollapsed = false;
                        scope.params.filters.timespan = scope.timespan;
                    }
                };
                scope.$watch('timespan', function(newValue){
                    if (!scope.timespanDatesCollapsed) {
                        scope.params.filters.timespan = newValue;
                    }
                }, true);
                scope.$watch('params.filters.time', function(newValue) {
                    scope.timespanDatesToggling(newValue, collapsingTarget);
                }, true);
                scope.timespanDatesToggling(scope.params.filters.time, collapsingTarget);
                var daysInMonth = function(month, year) {
                    return new Date(year, month, 0).getDate();
                };
                scope.monthDaysRange = function (month, year) {
                    var range = [];
                    for (var i = 1; i <= daysInMonth(month, year); i++) {
                        range.push(i);
                    }
                    return range;
                };
           }
        };
    });

ngModule.directive('filterColumn', ['$window',
    function($window) {
        return {
           restrict: 'A',
           scope: true,
           link: function(scope, element) {

              $($window).on('resize', function(){
                  if (!scope.group.facet_key && scope.group.description !== 'Trend') {
                    element.addClass('filter-label');
                  }
             });

             // Trigger the event handler on page load
             $($window).trigger('resize');
           }
        };
    }]);
